export default class VerticalTabs extends HTMLElement {
    constructor() {
        super();
        this.visualWrapperEl = null;
        this.currentVisualId = null;
    }

    showVisual(tabId) {
        const visualEl= this.visualWrapperEl.querySelector(`.media-wrapper[data-index="${tabId}"]`)
        const oldVisual = this.visualWrapperEl.querySelector(`.media-wrapper[data-index="${this.currentVisualId}"]`)

        if (oldVisual) {
            oldVisual.classList.remove('show')
            oldVisual.classList.toggle('hide', true)
        }

        if (visualEl) {
            visualEl.classList.remove('hide');
            visualEl.classList.toggle('show', true);

            this.currentVisualId = tabId;
        }
    }

    init() {
        const accordionEl = this.querySelector('accordion-with-visual');
        this.visualWrapperEl = this.querySelector('.visuals-wrapper');

        if (this.visualWrapperEl) {
            const mediasEl = this.visualWrapperEl.querySelectorAll('.media-wrapper');
            const tabs = this.querySelectorAll('accordion-with-visual .tab-item');

            if (mediasEl.length) {
                const els = Array.from(mediasEl);
                // Find the highest media
                const maxHeight = els.reduce((lastHeight, el) => {
                    const height = parseInt(el.dataset.height, 10);

                    return lastHeight > height ? lastHeight : height;
                }, 0);
                const maxRatioEl = this.visualWrapperEl.querySelector(`.media-wrapper[data-height="${maxHeight}"]`);
                if (maxRatioEl) {
                    const maxRatioHeight = maxRatioEl.dataset.ratio;
                    this.visualWrapperEl.style.setProperty('--max-ratio', `${maxRatioHeight}`)
                }
            }

            if (accordionEl) {
                accordionEl.addEventListener('ON_TAB_SELECTED', (customEventObj) => {
                    this.showVisual(customEventObj.detail.tabId);
                })
            }
        }
    }

    connectedCallback() {
        setTimeout(() => {
            this.init();
        });
    }
}